<template>
  <div
    class="rounded-full text-center flex items-center justify-center font-heading"
    :class="{
      'bg-r-300 text-n-0': mode === 'alert',
      'bg-v-500 dark:bg-v-300 text-n-0': mode === 'primary',
      'bg-n-600 dark:bg-n-0 text-n-0 dark:text-n-800': mode === 'secondary',

      'h-5 !text-[0.688rem]': type === 'large', // 11px
      'h-4 !text-[0.563rem]': type === 'small', // 9px

      'w-5': type === 'large' && !isText,
      'w-4': type === 'small' && !isText,
      'px-2 w-fit': isText
    }"
  >
    <span class="leading-[0]">
      {{ value ?? 0 }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

type Props = {
  type?: 'large' | 'small'
  mode?: 'primary' | 'secondary' | 'alert'
  value?: number | string | null
}

const props = withDefaults(defineProps<Props>(), {
  type: 'large',
  mode: 'primary',
  value: null
})

const isText = computed(() => {
  return props.value && typeof props.value === 'string' && props.value.length > 2
})
</script>
